import { render } from "./BuilderSettings.vue?vue&type=template&id=0fcfcf7e"
import script from "./BuilderSettings.vue?vue&type=script&lang=js"
export * from "./BuilderSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__